// Easter eggs — baptist, evangelical flavor, UBG-style wording.
// Mix of: short Bible verses (UBG), Latin/Greek acclamations, and small prayers.
// Used across the portal: click on logo, save actions, page visits, holy days.

export const CHRIST_QUOTES = [
  // St John's Gospel — central to evangelicals.
  { ref: 'J 3,16', text: 'Albowiem tak Bóg umiłował świat, że dał swojego jednorodzonego Syna.', lang: 'pl' },
  { ref: 'J 14,6', text: 'Ja jestem drogą, prawdą i życiem.', lang: 'pl' },
  { ref: 'J 14,27', text: 'Pokój zostawiam wam, mój pokój daję wam.', lang: 'pl' },
  // Sermon on the Mount.
  { ref: 'Mt 5,9', text: 'Błogosławieni czyniący pokój, albowiem nazwani będą synami Bożymi.', lang: 'pl' },
  { ref: 'Mt 5,14', text: 'Wy jesteście światłością świata. Nie może się ukryć miasto położone na górze.', lang: 'pl' },
  { ref: 'Mt 6,33', text: 'Szukajcie najpierw królestwa Bożego i jego sprawiedliwości.', lang: 'pl' },
  { ref: 'Mt 11,28', text: 'Przyjdźcie do mnie wszyscy, którzy jesteście spracowani i obciążeni.', lang: 'pl' },
  // Paul — faith, work, faithfulness.
  { ref: 'Flp 4,13', text: 'Wszystko mogę w tym, który mnie umacnia, w Chrystusie Jezusie.', lang: 'pl' },
  { ref: 'Kol 3,23', text: 'Cokolwiek czynicie, czyńcie z serca, jak dla Pana.', lang: 'pl' },
  { ref: 'Ga 5,22-23', text: 'Owocem Ducha jest miłość, radość, pokój, cierpliwość, uprzejmość, dobroć, wierność.', lang: 'pl' },
  { ref: 'Rz 8,28', text: 'Wiemy, że tym, którzy Boga miłują, wszystko służy ku dobremu.', lang: 'pl' },
  { ref: 'Łk 16,10', text: 'Wierny w małym i w wielkim wierny.', lang: 'pl' },
  { ref: 'Ef 2,8-9', text: 'Łaską bowiem jesteście zbawieni, przez wiarę. To nie z was, to dar Boga.', lang: 'pl' },
  { ref: '1 Kor 10,31', text: 'Czy jecie, czy pijecie, czy cokolwiek czynicie, czyńcie wszystko na chwałę Bożą.', lang: 'pl' },
  { ref: 'Ps 23,1', text: 'Pan jest moim pasterzem, nie brak mi niczego.', lang: 'pl' },
  { ref: 'Prz 3,5', text: 'Zaufaj Panu z całego serca i nie polegaj na własnym rozumie.', lang: 'pl' },
  { ref: 'Prz 16,3', text: 'Powierz Panu swoje dzieła, a twoje plany się spełnią.', lang: 'pl' },
  { ref: 'Iz 41,10', text: 'Nie lękaj się, bo Ja jestem z tobą.', lang: 'pl' },
  { ref: 'Jr 29,11', text: 'Ja znam plany, które mam wobec was — plany pokoju, a nie zła.', lang: 'pl' },
  { ref: 'Mi 6,8', text: 'Co Pan żąda od ciebie? Jedynie czynić sprawiedliwie, miłować miłosierdzie i pokornie chodzić z Bogiem.', lang: 'pl' },
];

export const CHRIST_ICONS = [
  { code: '✝', label: 'Krzyż' },
  { code: 'ΙΧΘΥΣ', label: 'Ryba — starożytny symbol chrześcijaństwa (Iesous Christos Theou Yios Soter)' },
  { code: '☩', label: 'Krzyż patriarchalny' },
  { code: '✟', label: 'Krzyż złamany' },
  { code: '☧', label: 'Chrystogram' },
  { code: 'PAX', label: 'Pokój' },
  { code: '✦', label: 'Gwiazda betlejemska' },
  { code: '☼', label: 'Światłość świata' },
];

export const CHRIST_LATIN = [
  'Pax Domui — Pokój temu domowi.',
  'Soli Deo Gloria — Jedynie Bogu chwała.',
  'Coram Deo — Przed obliczem Boga.',
  'Gratias agimus Deo — Dziękujemy Bogu.',
  'Dominus providebit — Pan zaopatrzy.',
  'Ad Maiorem Dei Gloriam — Na większą chwałę Bożą.',
  'Veni, Sancte Spiritus — Przyjdź, Duchu Święty.',
];

export const CHRIST_GREEK = [
  'Ἀγάπη — Miłość (agape).',
  'Χάρις — Łaska (charis).',
  'Εἰρήνη — Pokój (eirene).',
  'Πίστις — Wiara (pistis).',
  'Ἐλπίς — Nadzieja (elpis).',
  'Χριστός — Chrystus, Pomazaniec.',
];

export const CHRIST_PRAYERS = [
  'Dziękuję Ci, Panie, za ten dzień i za tych, których dziś spotykam.',
  'Panie Jezu, prowadź mnie w drodze — choćbym nie widział drogi.',
  'Duchu Święty, daj mi pokój w decyzjach, które dziś podejmuję.',
  'Boże, Ty widzisz serce — Ty je też utwierdzasz.',
  'Panie, uczyń mnie dzisiaj narzędziem Twojego pokoju.',
  'Jezu, ufam Tobie.',
  'Boże Abrahama, Izaaka i Jakuba — Ty jesteś wierny, choć my bywamy słabi.',
];

// Holy days of the year — moment-based easter eggs.
export const HOLY_DAYS = [
  { month: 1, day: 1, name: 'Nowy Rok', text: 'Nowy rok — nowe plany. „Ten, który rozpoczął w was dobre dzieło, dokończy go" (Flp 1,6).' },
  { month: 12, day: 25, name: 'Boże Narodzenie', text: 'Narodził się Chrystus Pan — Emmanuel, Bóg z nami. (Mt 1,23)' },
  { month: 12, day: 26, name: 'Św. Szczepana', text: '„Panie Jezu, przyjmij ducha mego" — pierwszy męczennik wiary. (Dz 7,59)' },
  { month: 4, day: 9, name: 'Wielki Piątek (przybliżone)', text: 'Krzyż — znak naszej wiary. „Tak Bóg umiłował świat". (J 3,16)' },
  { month: 4, day: 12, name: 'Wielkanoc (przybliżone)', text: 'Chrystus zmartwychwstał — prawdziwie zmartwychwstał! Alleluja.' },
  { month: 5, day: 31, name: 'Zielone Świątki (przybliżone)', text: 'Duch Święty zstąpił — moc z wysoka. (Dz 2,4)' },
  { month: 6, day: 1, name: 'Dzień Dziękczynienia', text: '„W każdym położeniu dziękujcie" — 1 Tes 5,18.' },
  { month: 11, day: 1, name: 'Wszystkich Świętych', text: 'Wielkie obloki świadków — patrzą na nas. (Hbr 12,1)' },
  { month: 11, day: 11, name: 'Święto Niepodległości', text: 'Boże, błogosław temu domowi i tej ziemi.' },
  { month: 8, day: 15, name: 'Wniebowzięcie NMP (w tradycji)', text: 'Maryja — służebnica Pańska, wzór wiary.' },
];

// Pool of all the easter items in one place.
export function getAllEggs() {
  const all = [];
  for (const q of CHRIST_QUOTES) all.push({ kind: 'quote', ...q });
  for (const ic of CHRIST_ICONS) all.push({ kind: 'icon', text: ic.code, label: ic.label });
  for (const l of CHRIST_LATIN) all.push({ kind: 'latin', text: l });
  for (const g of CHRIST_GREEK) all.push({ kind: 'greek', text: g });
  for (const p of CHRIST_PRAYERS) all.push({ kind: 'prayer', text: p });
  return all;
}

export function getTodayHolyDay(date = new Date()) {
  const m = date.getMonth() + 1;
  const d = date.getDate();
  return HOLY_DAYS.find(h => h.month === m && h.day === d) || null;
}

export function pickRandomEgg(seed) {
  const all = getAllEggs();
  // Tiny stable hash to make the same seed (e.g. user+page) map to the same egg — feels intentional.
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return all[h % all.length];
}
